import { v1 } from "@/axios"

interface ICompleteMultipartRequest {
  uploadId: string
  key: string
  parts: Array<{
    partNumber?: number
    etag?: string
  }>
}

export async function notifyMultipartUploadComplete(data: ICompleteMultipartRequest, eventVaultId: number) {
  await v1.post(`/upload/${eventVaultId}/multipart/complete`, data)
}
